export default "__VITE_ASSET__C$RAi0En__"